import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const EditRoleModal = ({
  show,
  onHide,
  onSave,
  roles = [],
  selectedRoleId,
  onRoleChange,
  customerName = "",
}) => {
  return (
    <Modal show={show} size="md" onHide={onHide}>
      <Modal.Header closeButton>
        <div className="modal-title h4">Edit Role</div>
      </Modal.Header>
      <Modal.Body>
        {customerName && (
          <p className="mb-2" style={{ fontSize: "0.875rem" }}>
            <strong>Customer:</strong> {customerName}
          </p>
        )}
        <Form.Group>
          <Form.Label className="fw-bold" style={{ fontSize: "0.875rem" }}>Customer Role</Form.Label>
          <Form.Select
            size="sm"
            value={selectedRoleId ?? ""}
            onChange={(e) => onRoleChange(e.target.value)}
          >
            <option value="">Select a role</option>
            {roles.map((role) => (
              <option key={role.roleId} value={role.roleId}>
                {role.roleName}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant="primary" onClick={onSave} disabled={!selectedRoleId}>
          Save
        </Button>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditRoleModal;
